module.exports = __webpack_public_path__ + "img/wallet_02_cross_2.2b576544.png";